<template>
  <div id="app">
    <UserList v-bind:users="users" v-on:changeUser="changeUser"></UserList>
    <router-view v-bind:hasList="hasList" v-bind:parent="parent" ref="list"/>
  </div>
</template>

<script>
import UserList from './components/UserList'
import lscache from 'lscache'

export default {
  name: 'App',
  beforeCreate: function () {
    console.log('login check')
    let hashPart = window.location.href
    hashPart = hashPart.split('#')[1]

    if (typeof hashPart !== 'undefined' && hashPart.includes('access_token')) {
      this.$oauth.createCookies(hashPart)
    } else if (typeof this.$cookies.get('access_token') === 'undefined' || this.$cookies.get('access_token') === null) {
      this.$oauth.logIn()
      return
    }
    if (typeof this.$route.params.user === 'undefined' && this.$route.path === '/') {
      this.$router.push({ path: "/list/" + this.$oauth.getCurrentUser()})
      return
    }
  },
  methods: {
    changeUser(event) {
      console.log(event)
      this.$refs.list.loadWishes()
    }
  },
  created () {
    if (lscache.get('users')) {      
      try {
        this.users = lscache.get('users');
      } catch(e) {
        localStorage.removeItem('cats');
      }
    } else {
      this.$api.userlist(this, function(component, data) {
        lscache.set('users', data, 30);
        component.users = data
      })
    }
    var user = this.$oauth.getCurrentUser()
    const currentUser = this.users.filter(u => u.username == user);
    const currentUserFamily = this.users.filter(u => {
      if('parent' in u && u.parent === true) return false
      return u.family == currentUser[0].family 
    })
    console.log(currentUserFamily)
    console.log(currentUser[0])
    this.family = currentUserFamily.map(u => u.username)
    this.parent = ('parent' in currentUser[0] && currentUser[0].parent === true) && this.family.includes(this.$route.params.user)
  },
  computed: {
    hasList: function() {      
      var user = this.$oauth.getCurrentUser()
      const lists = this.users.filter(u => u.username == user);
      return lists.length > 0;
    },
  },
  data () {
    return {
      users: [],
      family: [],
      parent: false
    }
  },
  components: {UserList}
}
</script>

<style>

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}

body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}

#app {
  
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
  display: flex;
  flex-wrap: wrap;
}

h1 {
	font-family: Trebuchet MS, Verdana, Arial, Sans-serif;
	font-size: 1.8em;
	margin: 10px;
  text-align: center;
}
@media only screen and (min-width: 601px) {
  h1 {
    text-align: left;
  }
}
</style>
